import styled from "styled-components";

export const ModalWrapper = styled.div`
 
`

export const ConfirmationHeader = styled.h1`
    font-family: Athletics;
    font-weight: 500;
    font-size: 20px;
    line-height: 32px;
`

export const ConfirmationTextBody = styled.p`
    font-family: Inter;
    font-weight: 400;
    font-size: 16px;
    line-height: 24px;
    margin-top: 8px;
`

export const ButtonsDiv = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-top: 24px;

  & > *:first-child {
    margin-right: 10px;
  }
    
  & > * {
    width: max(146px, 47%);
  }
`;